function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// src/components/close-button.ts
import { defineStyle, defineStyleConfig } from "@chakra-ui/styled-system";
import { cssVar } from "@chakra-ui/theme-tools";
var $size = cssVar("close-button-size");
var $bg = cssVar("close-button-bg");
var baseStyle = defineStyle({
  w: [$size.reference],
  h: [$size.reference],
  borderRadius: "md",
  transitionProperty: "common",
  transitionDuration: "normal",
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed",
    boxShadow: "none"
  },
  _hover: _defineProperty(_defineProperty({}, $bg.variable, "colors.blackAlpha.100"), "_dark", _defineProperty({}, $bg.variable, "colors.whiteAlpha.100")),
  _active: _defineProperty(_defineProperty({}, $bg.variable, "colors.blackAlpha.200"), "_dark", _defineProperty({}, $bg.variable, "colors.whiteAlpha.200")),
  _focusVisible: {
    boxShadow: "outline"
  },
  bg: $bg.reference
});
var sizes = {
  lg: defineStyle(_defineProperty(_defineProperty({}, $size.variable, "sizes.10"), "fontSize", "md")),
  md: defineStyle(_defineProperty(_defineProperty({}, $size.variable, "sizes.8"), "fontSize", "xs")),
  sm: defineStyle(_defineProperty(_defineProperty({}, $size.variable, "sizes.6"), "fontSize", "2xs"))
};
var closeButtonTheme = defineStyleConfig({
  baseStyle: baseStyle,
  sizes: sizes,
  defaultProps: {
    size: "md"
  }
});
export { closeButtonTheme };